import React, { useState } from "react";
import trainerPlaceholder from "../assets/trainer-placeholder.png";

export type TrainerImageProps = {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  onError?: () => void;
};

const TrainerImage: React.FC<TrainerImageProps> = ({
  src,
  alt,
  className = "",
  style = {},
  onError,
}) => {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    console.error('[TrainerImage] Failed to load image src:', (e.target as HTMLImageElement).src);
    setImageError(true);
    setIsLoading(false);
    onError?.();
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  // If there was an error loading the original image, show placeholder
  if (imageError) {
    return (
      <img
        src={trainerPlaceholder}
        alt={alt}
        className={className}
        style={style}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={handleError}
      onLoad={handleLoad}
    />
  );
};

export default TrainerImage;